import { APP_INITIALIZER, ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import {
    GoogleMapsLoaderService,
    initializeMaps,
} from 'clicklease-ui-elements';
import { routes } from './app.routes';
import { provideEffects } from '@ngrx/effects';
import {
    AuthDataFeature,
    AuthDataEffect,
    BankAccountEffectsService,
    BankAccountFeature,
    BankAccountsFeature,
    BusinessInfoFeature,
    BusinessInfoFormFeature,
    BusinessInfoEffectsService,
    ContractsFeature,
    ContractsEffectsService,
    PaymentsEffectsService,
    PaymentsFeature,
    PersonalInfoFormFeature,
    PersonalInfoFeature,
    PersonalInfoEffectsService,
    BankAccountFormFeature,
    AuthInterceptor,
    BankAccountFormEffect,
    EquipmentLocationFormEffect,
    EquipmentLocationFormFeature,
    DownloadStatementFormEffect,
    DownloadStatementFormFeature,
    DownloadLeaseAgreementFeature,
    DownloadLeaseAgreementEffectsService,
    DisclosureLogingFeature,
    DisclosureLoginEffect,
    PaymentLinkFeature,
    PaymentLinkEffect
} from './core';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(
            withInterceptors([AuthInterceptor])
        ),
        provideStore(),
        provideState(AuthDataFeature),
        provideState(BankAccountFeature),
        provideState(BankAccountsFeature),
        provideState(BusinessInfoFeature),
        provideState(BusinessInfoFormFeature),
        provideState(PaymentsFeature),
        provideState(PersonalInfoFeature),
        provideState(PersonalInfoFormFeature),
        provideState(ContractsFeature),
        provideState(BankAccountFormFeature),
        provideState(EquipmentLocationFormFeature),
        provideState(DownloadStatementFormFeature),
        provideState(DownloadLeaseAgreementFeature),
        provideState(DisclosureLogingFeature),
        provideState(PaymentLinkFeature),
        provideEffects(
            AuthDataEffect,
            BankAccountEffectsService,
            BusinessInfoEffectsService,
            ContractsEffectsService,
            PaymentsEffectsService,
            PersonalInfoEffectsService,
            BankAccountFormEffect,
            EquipmentLocationFormEffect,
            DownloadStatementFormEffect,
            DownloadLeaseAgreementEffectsService,
            DisclosureLoginEffect,
            PaymentLinkEffect
        ),
        provideAnimationsAsync(),
        provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
        GoogleMapsLoaderService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeMaps,
            deps: [GoogleMapsLoaderService],
            multi: true,
        },
    ],
};
